import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from '../../base.service';
import { SecuritymenuService } from '../../services/securitymenu.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: []
})
export class IndexComponent implements OnInit {

  title_component: string;
  title_panel: string;
  links = [];
  list_show = [];


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private baseService: BaseService,
    private securitymenuService: SecuritymenuService
  ) {}

  ngOnInit(): any {
    this.title_component = 'Dashboard';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Dashboard';

    this.list_show = [
      'HISTORIAL DE COMPRAS',
      'CATEGORIAS',
      'PRODUCTOS',
      'NOTIFICACION GENERAL',
      'NOTIFICACION POR USUARIO',
      'PUNTOS DEL USUARIO',
      'HISTORIAL DE OFERTAS',
      'USUARIOS',
      'COMENTARIOS',
    ];

    this.securitymenuService.getAll()
      .subscribe(data => {
        if (data) {
          const rutas = [];
          for (let j = 0; j < this.list_show.length; j++) {
             const name_item_list = this.list_show[j];
             data.forEach(function (link) {
              if (link.systemOption.name === name_item_list) {
                rutas.push(link.systemOption);
              }
            });
          }
          this.links = rutas;
        }
      });
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/index/index.component.ts